import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@arcadeai/design-system/components/ui/atoms/collapsible";
import { ChevronDown } from "lucide-react";
import type { UseFormReturn } from "react-hook-form";
import type { ServerForm } from "@/app/servers/types";
import { RetryField } from "./retry-field";
import { TimeoutField } from "./timeout-field";

type AdvancedSettingsCollapsibleProps = {
  form: UseFormReturn<ServerForm>;
  canUpdate: boolean;
  type: "http" | "mcp";
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
};

export const AdvancedSettingsCollapsible = ({
  form,
  canUpdate,
  type,
  isOpen,
  onOpenChange,
}: AdvancedSettingsCollapsibleProps) => (
  <Collapsible onOpenChange={onOpenChange} open={isOpen}>
    <div className="rounded-lg border border-border">
      <CollapsibleTrigger
        render={
          <button
            className="flex w-full cursor-pointer items-center justify-between rounded-lg bg-transparent p-4 transition-colors hover:bg-accent"
            type="button"
          />
        }
      >
        <div className="flex items-center gap-2">
          <span className="font-medium text-sm">Advanced Settings</span>
          <span className="text-muted-foreground text-xs">
            Connection Settings
          </span>
        </div>
        <ChevronDown
          className={`size-4 text-muted-foreground transition-transform ${isOpen ? "rotate-180" : ""}`}
        />
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="space-y-4 border-border border-t p-4">
          <TimeoutField canUpdate={canUpdate} form={form} type={type} />
          <RetryField canUpdate={canUpdate} form={form} type={type} />
        </div>
      </CollapsibleContent>
    </div>
  </Collapsible>
);
